import TeamGallery from "../Teams";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import ContactFooter from '../ContactFooter';
import './about.css'
import '../Teams/teams.css'
import useScrollTo from "../../hooks/useScrollTo";


const Teams = () => {
  useScrollTo();

  return (
    <>
      <div className='about-container'>
        <Container fluid>
          <Row>
            <Col xs={12} md={7} style={{ float: 'left' }}>
              <h1>
                RIOT labs&nbsp; &nbsp;
              </h1>
              <h6 >
                Part of Capgemini AIE
              </h6>
              <br />
              <h3 >
                The Capgemini Rapid Innovation & Operations team&nbsp;
              </h3>
              <br />
              <h4>
                Who are we?
              </h4>
              <p>
                Introducing RIOT Labs - where rapid innovation meets fastpaced operations.
                Our team, established early 2023 and hosted by AIE Nordics in Malmö,
                is dedicated to driving cutting-edge projects. Colleagues can join us
                for a short sprint or a longer journey as we boldly explore the frontiers
                of emerging technology. Our goal is to create tangible demonstrations
                that showcase the power of our offerings, because as they say, seeing is
                believing
              </p>
            </Col>
            <Col xs={12} md={4} style={{ textAlign: 'right' }}>
              <img alt="cute robot"
                class="about-images"
                src="https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/images%2FWho.png?alt=media&token=b974179f-e290-421c-8a3e-7faad0cce4f2" />
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={12} md={4} style={{ float: "left" }}>
              <img alt="cute robot"
                class="about-images"
                src="https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/images%2FWhat.png?alt=media&token=a7f2d8be-0cc8-4ef8-a85b-1132a1c09e2c" />
            </Col>
            <Col xs={12} md={7} style={{ float: "left" }}>

              <br />
              <br />
              <h4>
                What do we do?
              </h4>
              <p class="right-aligned">
                Introducing RIOT Labs - where rapid innovation meets fastpaced operations.
                Our team, established early 2023 and hosted by AIE Nordics in Malmö,
                is dedicated to driving cutting-edge projects. Colleagues can join us
                for a short sprint or a longer journey as we boldly explore the frontiers
                of emerging technology. Our goal is to create tangible demonstrations
                that showcase the power of our offerings, because as they say, seeing is
                believing

              </p>
            </Col>
          </Row>
          <br />
          <br />
          <br />
          <br />
          <Row>
            <Col xs={12} md={11} style={{ float: "left" }}>
              <h4>
                The team behind the magic
              </h4>
              <p>
                Working with the RIOT Labs team is a unique experience.
                We embrace diversity, curiosity, and creativity, and we encourage each
                other to push boundaries and challenge the status quo. We believe that
                true innovation comes from collaboration and a shared passion for
                excellence. We welcome people from all walks of life, with different
                skills, backgrounds, and perspectives, because we know that diversity
                is the key to success.

              </p>
              <TeamGallery />
            </Col>
          </Row>
        </Container>
      </div >

      <ContactFooter />
    </>
  );
}

export default Teams;
